import styled from 'styled-components';
import { Form } from 'components/atoms/form';
import { Select as AtomSelect } from 'components/atoms/select';
import { Caption01, BodyShort01, ProductiveHeading07 } from 'components/styles';

export const Content = styled.div`
  padding: var(--spacing-05);
  min-height: 500px;
  .ant-form-item {
    flex-direction: column;
    align-items: flex-start;
  }
  .ant-form-item-control-input {
    min-width: 200px;
  }
  .ant-form-item-control {
    width: 100%;
  }
`;

export const ConfigItems = styled.div`
  display: flex;
  ${BodyShort01};
  gap: var(--spacing-03);
  align-items: center;
  min-width: 200px;
`;

export const PublishDescription = styled.p`
  ${Caption01};
  margin-bottom: var(--spacing-05);
  color: var(--cool-gray-70);
`;

export const ConfigTitle = styled.p`
  ${ProductiveHeading07};
  margin: var(--spacing-07) 0 var(--spacing-04);
`;

export const WeekSelect = styled.div`
  display: flex;
  gap: var(--spacing-06);
  flex-wrap: wrap;
  margin-bottom: var(--spacing-06);
`;

export const NumberSelect = styled(AtomSelect)`
  flex-basis: 96px;
`;

export const Select = styled(AtomSelect)`
  flex-grow: 1;
`;

export const WeekLabel = styled.div`
  line-height: 40px;
`;

export const OnDaySelector = styled(Form.Item)`
  flex-basis: 100%;
  flex-shrink: 0;
  &.ant-form-item {
    margin-bottom: var(--spacing-05);
    padding-bottom: 0;
  }
`;

export const FilterProjects = styled.div`
  margin-left: var(--spacing-03);
  button {
    padding-top: 0;
    padding-bottom: 0;
    height: auto;
  }
`;

export const FilterWrapper = styled.div`
  padding: var(--spacing-03) var(--spacing-06) 0 var(--spacing-06);
`;

export const FreqSelectorWrapper = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;
export const NextUpdate = styled.div`
  color: var(--blue-60);
`;

export const FilterProjectsBtns = styled.div`
  padding: var(--spacing-07);
  display: flex;
  justify-content: flex-end;
`;

export const FilterBoxWrapper = styled.div`
  padding: var(--spacing-04) var(--spacing-05);
`;
